import type { ReactNode } from 'react';

import type { NormalizedFieldHelpProps, VNFieldHelpProps } from './types';

function resolveHelperLink(
  helperLink?: string,
  learnMore?: string | { href: string; label?: string }
): string | undefined {
  if (helperLink) return helperLink;
  if (!learnMore) return undefined;
  if (typeof learnMore === 'string') return learnMore;
  return learnMore.href;
}

function resolveHelperTooltip(helperTooltip?: string, infoTooltip?: ReactNode): string | undefined {
  if (helperTooltip) return helperTooltip;
  if (infoTooltip == null || infoTooltip === '') return undefined;
  return typeof infoTooltip === 'string' ? infoTooltip : String(infoTooltip);
}

function resolveHelperText(helperText?: string, helpText?: ReactNode): string | undefined {
  if (helperText) return helperText;
  if (helpText == null || helpText === '') return undefined;
  return typeof helpText === 'string' ? helpText : String(helpText);
}

export function pickFieldHelpProps(props: VNFieldHelpProps): VNFieldHelpProps {
  const {
    helperTooltip,
    helperText,
    helperContent,
    helperLink,
    helperContentTitle,
    dropDownItemHelperTooltip,
    dropDownItemHelperText,
    infoTooltip,
    helpText,
    learnMore,
    drawerContent,
    drawerTitle,
    dropDownItemToolTips,
  } = props;

  return {
    helperTooltip,
    helperText,
    helperContent,
    helperLink,
    helperContentTitle,
    dropDownItemHelperTooltip,
    dropDownItemHelperText,
    infoTooltip,
    helpText,
    learnMore,
    drawerContent,
    drawerTitle,
    dropDownItemToolTips,
  };
}

export function normalizeFieldHelpProps(props: VNFieldHelpProps): NormalizedFieldHelpProps {
  const {
    helperTooltip,
    helperText,
    helperContent,
    helperLink,
    helperContentTitle,
    dropDownItemHelperTooltip,
    dropDownItemHelperText,
    infoTooltip,
    helpText,
    learnMore,
    drawerContent,
    drawerTitle,
    dropDownItemToolTips,
  } = props;

  return {
    helperTooltip: resolveHelperTooltip(helperTooltip, infoTooltip),
    helperText: resolveHelperText(helperText, helpText),
    helperContent: helperContent ?? drawerContent,
    helperLink: resolveHelperLink(helperLink, learnMore),
    helperContentTitle: helperContentTitle ?? drawerTitle,
    dropDownItemHelperTooltip: dropDownItemHelperTooltip ?? dropDownItemToolTips,
    dropDownItemHelperText,
  };
}
